<template>
  <footer class="main-footer">
    <div class="d-flex">
      {{ $t("page.order.footer.title") }}
      <p>{{ $t(user.locationTranslationKey) }}, {{ $t(medKeyTypeName) }}</p>
      <a class="version" @click="isVersionPopupShown = true">
        Version
      </a>
      <version-popup v-if="isVersionPopupShown" @close="isVersionPopupShown = false"></version-popup>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";
import VersionPopup from "./pills/version-popup";

export default {
  name: "VFooter",
  components: { VersionPopup },
  data() {
    return {
      isVersionPopupShown: false
    };
  },
  computed: {
    ...mapGetters({
      user: "user/userDetails",
      medKeyTypeName: "medKey/currentMedKeyTypeName"
    })
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/variables";
.main-footer {
  padding: 8px 24px;
  background-color: $color-lightgrey;
  font-size: 13px;
  color: #999999;
  letter-spacing: 0.3px;
  p {
    color: #004593;
    font-weight: bold;
    margin-left: 6px;
    text-transform: capitalize;
  }
  .version {
    text-align: right;
    margin-left: auto;
  }
}
</style>
